/* eslint-disable import/prefer-default-export */
// export const PRODUCT_API_BASE = 'http://www.dandmbooks.com/productapi/api';
// export const CONTENT_API_BASE = 'http://www.dandmbooks.com/contentapi/api';
export const IDENTITY_SERVER_BASE = 'https://uat-identity.dandmbooks.co.uk/identity';
export const PRODUCT_API_BASE = 'https://uat-api.dandmbooks.co.uk/api';
export const CONTENT_API_BASE = 'https://uat-api.dandmbooks.co.uk/api';
// export const IDENTITY_SERVER_BASE = 'https://localhost:5007';
export const API_CLIENT_ID = 'MJSWeb.WebShop.APIClient';
export const API_CLIENT_SECRET = 'MJSWeb.WebShop.API.Secret';
export const API_SCOPE = 'publicaccessapi';
export const EBAY_SHOP_URL = 'https://www.ebay.co.uk/str/dandmvintagebooksandcomics';



// WEBPACK FOOTER //
// ./src/config.js